import { useMemo } from "react";
import type { API_V1 } from "./version_1/api_v1";
import type { API_V2 } from "./version_2/api_v2";
import api_v1 from "./version_1/api_v1";
import api_v2 from "./version_2/api_v2";
import { getAuthToken } from "../utils/storeUtils";
import { setIsAuthorizedDirectly } from "../../contexts/userContext";
import { toast } from "react-toastify";
import { SitePath } from "../constants";

const redirectToSellUsed = () => {
  if (typeof window !== "undefined") {

    window.location.assign(SitePath.SELL_NOW_PAGE);
  }
};

const backendUrl = process.env.REACT_APP_BACKEND_URL
export interface API {
  API_V1: API_V1;
  API_V2: API_V2;
}
export type Tparams = string|number|string[]| number[];
export type FetchJson = <T>(
  input: RequestInfo,
  init?: RequestInit,
  parseResponse?: boolean
) => Promise<T>;

export type FetchJsonWithParams = <T>(
  input: RequestInfo,
  params?:Tparams,
  query?: Record<any, any>,
  init?: RequestInit,
  parseResponse?: boolean
) => Promise<T>;

export type FetchJsonWithQuery = <T>(
  input: RequestInfo,
  query?: {params?:Tparams, query?:any},
  init?: RequestInit,
  parseResponse?: boolean
) => Promise<T>;

export type FetchJsonWithParamsAndQuery = <T>(
  input:RequestInfo,
  params:Tparams,
  query:any,
  parseResponse?:boolean
) => Promise<T>

export type PostJsonWithQuery = <T>(
  input:RequestInfo,
  query:any,
  body:any,
  parseResponse?:boolean
) => Promise<T>

export type PostJson = <T>(
  input: RequestInfo,
    body:any,
    params?:Tparams,
  query?:any,
  init?: RequestInit,
  parseResponse?:boolean
) => Promise<T>;

export type PostJsonApi = <T>(
  input: RequestInfo,
  body:any,
  params?:Tparams,
  query?:Record<string, any>,
  init?: RequestInit,
  parseResponse?:boolean

) => Promise<T>;

export type PatchJson = <T>(
  url: RequestInfo,
  data: any,
  params?:Tparams,
  query?:Record<string, any>,
  init?: RequestInit,
  parseResponse?: boolean
) => Promise<T>;

export type DeleteJson = <T>(
  url: RequestInfo,
  params?:Tparams,
  query?:Record<string, any>,
  init?: RequestInit,
  parseResponse?: boolean
) => Promise<T>;

export type PostRequest = <T>(
  url: RequestInfo,
  data: any,
  withAuth?:Boolean,
  parseResponse?: boolean
) => Promise<T>

export type PatchRequest = <T>(
  url: RequestInfo,
  data: any,
  withAuth?:Boolean,
  parseResponse?: boolean
) => Promise<T>

export type DeleteRequest = <T>(
  url: RequestInfo,
  withAuth?:Boolean,
  parseResponse?: boolean
) => Promise<T>;

export interface Response {
  code: number;
  data: any;
  page: { limit: number; total: number };
}


async function  fetchCsrfToken () {
    const response = await fetch(`${backendUrl}api/v1/csrf-token`,
      {  method: 'GET',
        headers:{
          // Accept:'aplication/json',
          "Content-Type": "application/json",
  
        },
        credentials: "include",
        mode:"cors"
  
      }
    );
   
    return response.json() 
  };


const fetchJson: FetchJson = async (
  input,
  init,
  parseResponse = true
) => {
  const baseUrl = process.env.REACT_APP_BACKEND_URL;
  const api = baseUrl + input;
  const response = await fetch(api, { method: "GET", ...init });
  
   // Handle 403 Forbidden - Set isAuthorized to false
  if (response.status === 403) {
    setIsAuthorizedDirectly(false);
    return 
    toast.error("Session Expired");
   
    redirectToSellUsed();
  }
  
  if (!response.ok) {
    try {
      throw await response.json();
    } catch (error) {
      if (error) throw error;
      else throw new Error("Request failed");
    }
  }
  return parseResponse ? response.json() : response;
};


const postJson:PostRequest   = async (
  url,
  data,
  withAuth=false,
  parseResponse = true
) => {
  
  const auth_token =  getAuthToken()  // localStorage.getItem("auth_token")
  const baseUrl = process.env.REACT_APP_BACKEND_URL;
  const api = baseUrl + url;
  const headers = new Headers()

  const token = await fetchJson<{csrfToken:string}>('api/v1/csrf-token', {credentials:'include'})
  headers.set('X-CSRF-Token', token.csrfToken)
  headers.set('Content-Type', 'application/json')
  if (withAuth) {
    if (!auth_token) {
      console.error("session-expired");
      // return;
    }
    headers.set("auth-token", auth_token as string);
  }


  const response = await fetch(api, { 
    method: "POST", 
    body:JSON.stringify(data), 
    headers, 
    credentials: "include",
  });

  // Handle 403 Forbidden - Set isAuthorized to false
  if (response.status === 403) {
    setIsAuthorizedDirectly(false);
    return 
    toast.error("Session Expired");

    redirectToSellUsed();
  }
  if (!response.ok) {
    try {
      throw await response.json();
    } catch (error) {
      if (error) throw error;
      else throw new Error("Request failed");
    }
  }
  return parseResponse ? response.json() : response;
};

const patchJson:PatchRequest   = async (
  url,
  data,
  withAuth=false,
  parseResponse = true
) => {
  const auth_token = getAuthToken() //localStorage.getItem("auth_token")
  const baseUrl = process.env.REACT_APP_BACKEND_URL;
  const api = baseUrl + url;
  const headers = new Headers()

  const token = await fetchJson<{csrfToken:string}>('api/v1/csrf-token', {credentials:'include'})
  headers.set('X-CSRF-Token', token.csrfToken)
  headers.set('Content-Type', 'application/json')
  if(withAuth) {
    if(!auth_token){
    console.error("session-expired")
    return 
  }
  headers.set('auth-token', auth_token )
  }


  const response = await fetch(api, { 
    method: "PATCH", 
    body:JSON.stringify(data), 
    headers, 
    credentials: "include",
  });

  // Handle 403 Forbidden - Set isAuthorized to false
  if (response.status === 403) {
    setIsAuthorizedDirectly(false);
     return 
    toast.error("Session Expired");

    redirectToSellUsed();
  }
  if (!response.ok) {
    try {
      throw await response.json();
    } catch (error) {
      if (error) throw error;
      else throw new Error("Request failed");
    }
  }
  return parseResponse ? response.json() : response;
};

const deleteJson:DeleteRequest   = async (
  url,
  withAuth=false,
  parseResponse = true
) => {
  const auth_token =  getAuthToken()  // localStorage.getItem("auth_token")
 
  const baseUrl = process.env.REACT_APP_BACKEND_URL;
  const api = baseUrl + url;
  const headers = new Headers()

  const token = await fetchJson<{csrfToken:string}>('api/v1/csrf-token', {credentials:'include'})
  headers.set('X-CSRF-Token', token.csrfToken)
  headers.set('Content-Type', 'application/json')
  if (withAuth) {
    if (!auth_token) {
      console.error("session-expired");
      return;
    }
    headers.set("auth-token", auth_token);
  }


  const response = await fetch(api, { 
    method: "DELETE",
    headers, 
    credentials: "include",
  });

  // Handle 403 Forbidden - Set isAuthorized to false
  if (response.status === 403) {
    setIsAuthorizedDirectly(false);
    return 
    toast.error("Session Expired");

    redirectToSellUsed();
  }
  if (!response.ok) {
    try {
      throw await response.json();
    } catch (error) {
      if (error) throw error;
      else throw new Error("Request failed");
    }
  }
  return parseResponse ? response.json() : response;
};

const postJsonApi: PostJsonApi = async (
  input,
  body,
  params,
  query,
  init,
  parseResponse = true
) => {
  const csrfToken = await fetchCsrfToken().catch(()=>console.error('error in crsrf'));
  const auth_token = localStorage.getItem("auth_token");
    const headers = {
    'Content-Type': 'application/json',
    "auth-token": `${auth_token}`,
    'X-CSRF-Token': csrfToken.csrfToken,
     credentials: "include",
    ...(init?.headers || {}), // preserve any custom headers from init
  };
  //fetch auth token from context, cookies, localstorage
  const baseUrl = process.env.REACT_APP_BACKEND_URL;
  const api = baseUrl + input;
  const response = await fetch(api,
     { method: "POST",
       headers,
       body: JSON.stringify(body),
       });
  if (!response.ok) {
    try {
      throw await response.json();
    } catch (error) {
      if (error) throw error;
      else throw new Error("Request failed");
    }
  }
  return parseResponse ? response.json() : response;
};



const handleMultiParameter = (url:RequestInfo, params:Tparams) => {
  
  if(params)
    {
      if(Array.isArray(params)){
          let paramsArr = '';
          for(let i = 0; i < params.length; i++){
            const param = typeof params[i] == 'string' ? encodPathParams(params[i] as string) : params[i]
            paramsArr += `/${param}`
          }
            return `${url}${paramsArr}`
      }
      else{
        const param = typeof params == 'string' ? encodPathParams(params) : params
          return `${url}/${param}`
      }
        
    }else{
      return url
    }
 }


 function encodPathParams(path:string) {
 return  encodeURIComponent(path);
}

export const getRequest: FetchJsonWithParams = async (input, params=0) => {
  const url = params ? handleMultiParameter(input,params) : input;
  return  fetchJson(url, {});
};

export const getRequestWithQuery: FetchJsonWithQuery = async (input, query) => {
  const new_query = new URLSearchParams(query?.query);
  let url = query?.params ? handleMultiParameter(input, query.params) : input;
  url = url + "?" + new_query.toString();
  return fetchJson(url, {});
};

export const getRequestWithParamsAndQuery:FetchJsonWithParamsAndQuery= (input, param, query)=>{
  const new_query = new URLSearchParams(query);
  let url = param ? handleMultiParameter(input, param) : input;
 
  url = url + "?" + new_query.toString();

  return fetchJson(url, {});
} 

export const getRequestWithAuth:FetchJsonWithParams= (input, param, query)=>{
  
  const auth_token = getAuthToken() //localStorage.getItem("auth_token")
  // const auth_token = useSelector(selectAuthToken)

 
  if(!auth_token){
  //console.error("session-expired")
    
  }
 const headers = new Headers()
 headers.set('auth-token', auth_token as string )
 headers.set('Content-Type', 'application/json')

const options: RequestInit = {
  headers,
  credentials: 'include'
}

  let url = param? handleMultiParameter(input, param) : input;
  url = url ;

  if(query){
    Object.entries(query).forEach(([k, v])=>{
      if(Array.isArray(v)){
        k = v.join(',')
      }
    })

    const new_query = new URLSearchParams(query);
    url = url + "?" + new_query.toString();
  }
    
 
  return fetchJson(url, options);
} 


export const postRequest:PostJson= (url, data, params, query) => {
  const new_query = new URLSearchParams(query);
  url = params ? handleMultiParameter(url,params) : url;
  url = query ? url + "?" + new_query.toString() : url
  return postJson(url, data)
}

export const postRequestWithAuth:PostJson= (url, data, params, query) => {
   const new_query = new URLSearchParams(query);
  url = params ? handleMultiParameter(url,params) : url;
  url = query ? url + "?" + new_query.toString() : url
  const withAuthToken = true
  return postJson(url, data, withAuthToken)
}

export const patchRequest:PatchJson= (url, data, params, query) => {
  const new_query = new URLSearchParams(query);
  url = params ? handleMultiParameter(url,params) : url;
  url = query ? url + "?" + new_query.toString() : url
  return patchJson(url, data)
}


export const patchRequestWithAuth:PatchJson= (url, data, params, query) => {
  const withAuthToken = true
  const new_query = new URLSearchParams(query);
  url = params ? handleMultiParameter(url,params) : url;
  url = query ? url + "?" + new_query.toString() : url
  return patchJson(url, data, withAuthToken)
}

export const deleteRequestWithAuth:DeleteJson= (url, params, query) => {
   const new_query = new URLSearchParams(query);
  url = params ? handleMultiParameter(url,params) : url;
  url = query ? url + "?" + new_query.toString() : url
  const withAuthToken = true
  return deleteJson(url, withAuthToken)
}



export const useInitApi = (): API => {
  return useMemo(() => {
    return {
      API_V1: api_v1,
      API_V2: api_v2,
    };
  }, []);
};


